// extracted by mini-css-extract-plugin
export default {"login_section":"login_login_section__LRpQH","loginDiv":"login_loginDiv__g9FNY","form":"login_form__ab6fM","withQR":"login_withQR__600IM"};